<template>
  <div>
    <div v-if="order.completion.built">
      {{ progress.completed.num }} / {{ progress.assigned.num }} / {{ progress.waiting.num }} / {{ progress.missing.num }}
      <div class="progress progress-mini">
        <div class="progress-bar progress-bar-navy-light" :style="'width:' + progress.completed.pct + '%'"></div>
        <div class="progress-bar progress-bar-success" :style="'width:' + progress.assigned.pct + '%'"></div>
        <div class="progress-bar progress-bar-warning" :style="'width:' + progress.waiting.pct + '%'"></div>
        <div class="progress-bar progress-bar-danger" :style="'width:' + progress.missing.pct + '%'"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['order'],
  computed: {
    progress () {
      return {
        completed: {
          num: this.order.completion['site-moved'].completed,
          pct: this.order.completion['site-moved'].completed / this.order.size * 100
        },
        assigned: {
          num: this.order.completion['built'].assigned,
          pct: this.order.completion['built'].assigned / this.order.size * 100
        },
        waiting: {
          num: this.order.completion['added'].completed - this.order.completion['site-moved'].completed - this.order.completion['built'].assigned,
          pct: (this.order.completion['added'].completed - this.order.completion['site-moved'].completed - this.order.completion['built'].assigned) / this.order.size * 100
        },
        missing: {
          num: this.order.size - this.order.completion['added'].completed,
          pct: (this.order.size - this.order.completion['added'].completed) / this.order.size * 100
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Orders/BuildsBreakdown.vue